<template>
  <div
    class="relative min-h-screen flex items-center justify-center bg-[#202126] overflow-hidden w-full"
  >
    <!-- Brand top left -->
    <div
      class="absolute top-0 left-7 flex items-center gap-3 z-20 select-none w-full h-[10vh]"
    >
      <!-- Ícone -->
      <img :src="bannerTop" class="opacity-90 w-30 h-20" />
    </div>

    <!-- Background glow -->
    <div class="absolute inset-0 pointer-events-none z-0 overflow-hidden">
      <div
        class="absolute left-1/2 top-1/2 w-[600px] h-[600px] -translate-x-1/2 -translate-y-[45%] bg-red-600 opacity-25 blur-[50px] rounded-full"
      ></div>
    </div>

    <!-- web lines -->
    <div
      class="absolute inset-0 flex items-center justify-center pointer-events-none z-0"
    >
      <img :src="webLines" class="w-[900px] max-w-none opacity-50" />
    </div>

    <!-- Main Card -->
    <div
      class="relative z-10 w-[380px] max-w-sm bg-[#1f2227] border-2 border-red-500/20 rounded-xl px-8 py-10"
    >
      <!-- Logo -->
      <!-- <div class="flex justify-center mb-10"> -->
      <a class="flex justify-center mb-10" href="/">
        <img :src="logo" class="w-20 h-20 opacity-90" />
      </a>
      <!-- </div> -->

      <!-- Slot do Form -->
      <slot />
    </div>
  </div>
</template>

<script setup>
import logo from "@/assets/company/x-solution-mind-logo-rb.png";
import bannerTop from "@/assets/app/logo-banner-rb.png";
import webLines from "@/assets/app/web-lines-rb.png";
</script>
